import { BIXIN_WALLET } from "@/helpers/constants/routeName";

const isSafeRedirect = (value) => {
  if (!value) return false;

  try {
    const target = new URL(value, window.location.origin);
    const isRelativePath = value.startsWith("/") && !value.startsWith("//");

    return (
      (isRelativePath || target.origin === window.location.origin) &&
      /^https?:$/.test(target.protocol) &&
      target.pathname.startsWith("/trade/")
    );
  } catch {
    return false;
  }
};

export const getPostLoginRedirect = () => {
  const storedRedirect = localStorage.getItem("login_redirect");
  const queryRedirect = new URLSearchParams(window.location.search).get(
    "redirect_url",
  );
  localStorage.removeItem("login_redirect");

  const redirect = [storedRedirect, queryRedirect].find(isSafeRedirect);
  if (!isSafeRedirect(redirect)) return BIXIN_WALLET;

  const target = new URL(redirect, window.location.origin);
  return `${target.pathname}${target.search}${target.hash}`;
};
